interface FeatureHighlightProps {
  icon: string
  title: string
  description: string
}

export const FeatureHighlight: React.FC<FeatureHighlightProps> = ({
  icon,
  title,
  description,
}) => {
  return (
    <div className="flex flex-col gap-4 rounded-xl border border-border-light bg-surface-light p-6 transition-colors hover:border-primary/30 dark:border-border-dark dark:bg-surface-dark">
      <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10 text-primary">
        <span className="material-symbols-outlined">{icon}</span>
      </div>
      <div>
        <h3 className="mb-2 text-lg font-bold text-text-main-light dark:text-text-main-dark">
          {title}
        </h3>
        <p className="text-sm leading-relaxed text-text-sub-light dark:text-text-sub-dark">
          {description}
        </p>
      </div>
    </div>
  )
}

